import React from 'react'
import './Topbar.scss'
import Logo from '../Assets/Logo.svg'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'

const Topbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const Home = location.pathname === ('/home') || location.pathname === '/'
  const Products = location.pathname.includes('products')
  const ContactUs = location.pathname.includes('contact-us')

  return (
    <nav className='Topbar'>
      <img src={Logo} alt='Logo' draggable={false} onClick={() => {navigate('/home')}}/>
      <ul className='Navigation'>
        <button className={Home ? 'Active' : ''} onClick={() => {navigate('/home')}}>Home</button>
        <button className={Products ? 'Active' : ''} onClick={() => {navigate('/home/products')}}>Menu</button>
        <button className={ContactUs ? 'Active' : ''} onClick={() => {navigate('/home/about-preem')}}>About Preem</button>
        <button onClick={() => {navigate('/home/order')}} className='OrderNow'>
          Basket
          <svg width="1.5rem" height="1.125rem" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.95964 4.51259H3.49447L7.2526 0.303605C7.58626 -0.0707442 8.16569 -0.103296 8.53841 0.230363C8.91276 0.564021 8.94531 1.14345 8.61165 1.5178L5.93913 4.51259H14.1292L11.4567 1.5178C11.123 1.14345 11.1556 0.564021 11.5299 0.230363C11.9043 -0.103296 12.4821 -0.0707442 12.8174 0.303605L16.5739 4.51259H18.042H18.0615H19.4401C19.7493 4.51259 20.0016 4.76487 20.0016 5.07411V6.65777C20.0016 6.96702 19.7493 7.21929 19.4401 7.21929H18.2471L17.6335 14.9553C17.6172 15.1685 17.4577 15.3443 17.2445 15.3443H2.75716C2.54395 15.3443 2.38444 15.1685 2.36816 14.9553L1.75456 7.21929H0.561523C0.252279 7.21929 0 6.96702 0 6.65777V5.07411C0 4.76487 0.252279 4.51259 0.561523 4.51259H1.9401H1.95964ZM12.6416 7.52366H14.4173V12.6555H12.6416V7.52366ZM9.18783 7.52366H10.9619V12.6555H9.18783V7.52366ZM5.73405 7.52366H7.50977V12.6555H5.73405V7.52366Z" fill="black"/>
          </svg>
        </button>
      </ul>
    </nav>
  )
}

export default Topbar